import { Multiselect } from '@amzn/awsui-components-react-v3';
import React from 'react';
import { AccuracyButtonNewStyle } from '../../styles/common_styles';
import {findOptions} from "../reports/utils/buttons";

export class TrendFilter extends React.Component {

  render() {
    const disabled = Boolean(this.props.disabled);
    return (
      <div className={AccuracyButtonNewStyle}>
        <b> {this.props.text} </b>
          <Multiselect
            className={ this.props.classname }
            options={ this.props.options }
            label={ this.props.text }
            onChange={ this.props.onChange }
            placeholder={ this.props.text }
            filteringType={ 'auto' }
            keepOpen={ !disabled }
            disabled={ disabled }
            selectedOptions={ findOptions( this.props.options, this.props.selectedIds ) }
          />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/buttons/Trend_Filter.jsx